var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 5,
    height: 4,
    viewBox: "0 0 5 4",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "icon/navigation/arrow_drop_down_24px",
    opacity: 0.6,
    d: "M4.79355 2.3537L2.99006 0.238841C2.71849 -0.0796132 2.2798 -0.0796132 2.00823 0.238841L0.204731 2.3537C-0.233958 2.86813 0.079391 3.75 0.699126 3.75L4.30612 3.75C4.92586 3.75 5.23224 2.86813 4.79355 2.3537Z",
    fill: "#637083"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUp);
export default __webpack_public_path__ + "static/media/up.dd6afb92217a675201e6c53f0e3a0d0f.svg";
export { ForwardRef as ReactComponent };